import { apiSlice } from "../apislice";
import format from 'date-fns/format';
import {
  ALL_CLIENTS,
  ALL_MESSAGE_TEMPLATES_URL,
  CODEVALUES_URL,
  GET_ORG_APPILICATION_ID_AND_ACCOUNT_NUMBER,
  GETCIBIL_CREDENTIAL,
  GETCLIENT_CREDIT,
  GETCLIENT_CURRENTPLAN,
  GETSERVICE_RESPONSE,
  GROUP_URL,
  SERVICE_SUMMARY_URL,
  SERVICE_MODULES_URL,
  TRANSACTIONS_HISTORY_URL,
  SERVICE_DETAILS_URL,
  TOP_LEAST_SERVICES_URL,
  PROFILE_DETAILS_URL,
  PLANS_DETAILS_URL,
  SERVICE_URL,
  TRANSACTIONS_URL,
  MSG91_MESSAGE_TEMPLATE,
  GRAVITON_DETAILS,
  REVENUREDETAILS,
  REVENUEDETAILS,
  SERVICEUSAGE,
  BAR_CHART_URL,
} from "../../constants";

export const HomePageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGroupData: builder.query({
      query: ({ date, clientname }) => {
        // if (date !== "") {
        //   return {
        //     url: `${GROUP_URL}/${clientname}?${date}`,
        //   };
        // } else {
        //     const now = new Date();
        //     const twentyFourHoursAgo = new Date(now - 24 * 60 * 60 * 1000);

        //     const from = twentyFourHoursAgo.toISOString();
        //     const fromdate = changeDate(from);
        //     const to = now.toISOString();
        //     const todate = changeDate(to);
        return {
          url: `${GROUP_URL}/${clientname}?${date}`,
          // url: `${GROUP_URL}/${clientname}?from=${fromdate}&to=${todate}`,
        };
        // }
      },
      keepUnusedDataFor: 5,
    }),

    getServiceSummaryData: builder.query({
      query: ({clientname,fromDate,toDate}) => {
        // const finalDate = format(new Date(), 'yyyy-MM-dd');
        return {
          url: `${SERVICE_SUMMARY_URL}/${clientname}?fromDate=${fromDate}&toDate=${toDate}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 5,
      refetchOnMountOrArgChange:true,
    }),
    
    getServiceModulesData:builder.query({
      query:({clientname,groupId,fromDate,toDate})=>{
        // const finalDate = format(new Date(), 'yyyy-MM-dd');
        return{
          url:`${SERVICE_MODULES_URL}/${clientname}/${groupId}?fromDate=${fromDate}&toDate=${toDate}`,
          method:'GET',
        };
      },
      keepUnusedDataFor:5,
      refetchOnMountOrArgChange:true,
    }),

    getCreditRechargeTransactionHistory: builder.query({
      query: ({ clientname, limit = 15, offset = 0, fromDate, toDate, transactionId }) => {
        const params = new URLSearchParams();
    
        params.append('limit', limit);
        params.append('offset', offset);
    
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate) params.append('toDate', toDate);
        if (transactionId) params.append('transactionId', transactionId);
    
        return {
          url: `${TRANSACTIONS_HISTORY_URL}/${clientname}?${params.toString()}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 5,
      refetchOnMountOrArgChange: true,
    }),
    
    getServiceDetailsData: builder.query({
      query: ({ clientname, groupId, limit = 15, offset = 0, fromDate, toDate, requestedId, status }) => {
        const params = new URLSearchParams();
    
        params.append('limit', limit);
        params.append('offset', offset);
    
        if (requestedId) params.append('requestId', requestedId);
        if (status) params.append('status', status);
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate) params.append('toDate', toDate);
    
        return {
          url: `${SERVICE_DETAILS_URL}/${clientname}/${groupId}?${params.toString()}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 5,
      refetchOnMountOrArgChange: true,
    }),
    getTopLeastServicesData: builder.query({
      query: ({clientname,fromDate,toDate}) => {
        // const finalDate = format(new Date(), 'yyyy-MM-dd');
        return {
          url: `${TOP_LEAST_SERVICES_URL}/${clientname}?fromDate=${fromDate}&toDate=${toDate}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 5,
      refetchOnMountOrArgChange:true,
    }),
    getBarChartData:builder.query({
      query:({clientname,groupId,period})=>{
        return{
          url: `${BAR_CHART_URL}/${clientname}/${groupId}?period=${period}`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 5,
      refetchOnMountOrArgChange:true,
    }),
    getProfileData:builder.query({
      query:({clientname})=>{
        return{
          url:`${PROFILE_DETAILS_URL}/${clientname}`,
          method:'GET'
        };
      },
      keepUnusedDataFor:5,
      refetchOnMountOrArgChange:true,
    }),
    getPlansDetailsData:builder.query({
      query:({clientname,limit=15,offset=0})=>{
        const params = new URLSearchParams();
    
        params.append('limit', limit);
        params.append('offset', offset);
        return{
          url:`${PLANS_DETAILS_URL}/${clientname}?${params.toString()}`,
          method:'GET',
        };
      },
      keepUnusedDataFor:5,
      refetchOnMountOrArgChange:true,
    }),
    getServiceData: builder.query({
      query: ({ timeendpoint, moduleid, clientname, page }) => {
        return {
          url: `${SERVICE_URL}/${clientname}?${timeendpoint}&moduleid=${moduleid}&page=${page}`,
        };
      },
      keepUnusedDataFor: 5,
    }),
    getClientCredits: builder.query({
      query: (reqid) => ({
        url: `${GETCLIENT_CREDIT}/${reqid}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getAllClients: builder.query({
      query: ({ clientname }) => ({
        url: `${ALL_CLIENTS}/${clientname}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getCurrentPlan: builder.query({
      query: ({ clientname }) => ({
        url: `${GETCLIENT_CURRENTPLAN}/${clientname}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getServiceResponse: builder.query({
      query: ({ requestId, clientname }) => ({
        url: `${GETSERVICE_RESPONSE}/${requestId}/${clientname}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getCibilCredential: builder.query({
      query: ({ clientname }) => ({
        url: `${GETCIBIL_CREDENTIAL}/${clientname}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getTransactionHistory: builder.query({
      query: ({ clientname }) => ({
        url: `${TRANSACTIONS_URL}/${clientname}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getCodeValues: builder.query({
      query: () => ({
        url: `${CODEVALUES_URL}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getTemplatesWithLimit: builder.query({
      query: ({ page, clientname }) => ({
        url: `${ALL_MESSAGE_TEMPLATES_URL}?page=${page}&clientname=${clientname}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getApplicationIdAndOtherDetails: builder.query({
      query: () => ({
        url: `${GET_ORG_APPILICATION_ID_AND_ACCOUNT_NUMBER}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getMessageTemplateMsg91: builder.query({
      query: ({ clientId, templateId }) => ({
        url: `${MSG91_MESSAGE_TEMPLATE}/${templateId}`,

        header: {
          client_id: clientId,
        },
      }),
      keepUnusedDataFor: 5,
    }),
    getRevenueDetails: builder.query({
      query: ({ clientId, year }) => ({
        url: `${REVENUEDETAILS}/${clientId}?year=${year}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getServiceUsage: builder.query({
      query: ({ clientId, year, month }) => ({
        url: `${SERVICEUSAGE}/${clientId}?year=${year}&month=${month}`,
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});
export const {
  useGetGroupDataQuery,
  useLazyGetServiceSummaryDataQuery,
  useLazyGetServiceModulesDataQuery,
  useGetCreditRechargeTransactionHistoryQuery,
  useGetServiceDetailsDataQuery,
  useGetTopLeastServicesDataQuery,
  useGetBarChartDataQuery,
  useGetProfileDataQuery,
  useGetPlansDetailsDataQuery,
  useGetClientCreditsQuery,
  useGetServiceDataQuery,
  useGetAllClientsQuery,
  useGetCurrentPlanQuery,
  useGetServiceResponseQuery,
  useGetCibilCredentialQuery,
  useGetTransactionHistoryQuery,
  useGetCodeValuesQuery,
  useGetTemplatesWithLimitQuery,
  useGetApplicationIdAndOtherDetailsQuery,
  useGetMessageTemplateMsg91Query,
  useGetRevenueDetailsQuery,
  useGetServiceUsageQuery,
} = HomePageApiSlice;
